import logoSIA from "@assets/events-awards/logo-sia.png";
import { BlockTitle } from "@blocks/Blocks";
import Column from "@components/Grid/Column";

/**
 * Component to render SIA about page
 */
const SIAAboutPage = (): React.ReactElement => {
  return (
    <div data-testid="sia-about-page-component" className="font-public-sans">
      <Column rootClassName="px-0">
        <BlockTitle
          text="About"
          rootClassName="py-3 text-4xl md:text-6xl lg:text-8xl font-medium"
        />

        <p>
          The Sustainability Impact Awards (SI Awards), launched on 1 February
          2023, is jointly presented by The Business Times and UOB, with the
          Centre for Governance and Sustainability (CGS) at the National
          University of Singapore Business School as the knowledge partner.
        </p>

        <p className="pb-6">
          The awards aim to recognise individuals and corporates in Singapore
          that demonstrate leadership in sustainability. It comprises two main
          categories:
        </p>
      </Column>

      <Column rootClassName="px-0">
        <p>
          <strong>
            <u>Individual Category</u>
          </strong>
        </p>

        <p>
          This award recognises and celebrates outstanding individuals, from
          entities with a clear enterprise purpose in Singapore, who have
          contributed to advancing sustainability through their personal
          efforts. With good governance as a prerequisite, recipients will have
          demonstrated their leadership and advocacy in creating a positive
          impact on the environment and/or society.
        </p>

        <ul className="list-outside list-disc pb-6 pl-8">
          <li>Impact Leader of the Year</li>
          <li>Impact Leader Excellence Award</li>
        </ul>
      </Column>

      <Column rootClassName="px-0">
        <p>
          <strong>
            <u>Enterprise Category</u>
          </strong>
        </p>

        <p className="pb-6">
          This award recognises and celebrates outstanding enterprises in
          Singapore that have contributed to advancing sustainability. With good
          governance as a prerequisite and good internal sustainability
          practices as a foundation, these enterprises will have demonstrated
          their leadership in creating a positive impact on the environment
          and/or society.
        </p>
      </Column>

      <Column rootClassName="px-0">
        <p>
          <strong>SMEs</strong>
        </p>

        <ul className="list-outside list-disc pb-6 pl-8">
          <li>Impact Enterprise of the Year</li>
          <li>Impact Enterprise Excellence Award</li>
        </ul>
      </Column>

      <Column rootClassName="px-0">
        <p>
          <strong>Large Enterprises</strong>
        </p>

        <ul className="list-outside list-disc pb-6 pl-8">
          <li>Impact Enterprise of the Year</li>
          <li>Impact Enterprise Excellence Award</li>
        </ul>
      </Column>

      <Column rootClassName="px-0">
        <img
          src={logoSIA}
          alt="Sustainability Impact Awards logo"
          width={549}
          height={200}
        />
      </Column>

      <Column rootClassName="px-0">
        <BlockTitle
          text="Objective"
          rootClassName="py-3 text-4xl lg:text-8xl font-medium"
        />

        <p>
          The Sustainability Impact Awards aims to celebrate individuals and
          businesses which have taken the lead to contribute to environmental
          and societal well-being through their work. The emphasis is on the
          impact that winners make to the sustainable progress of communities
          through their initiatives, rather than sustainability for its own
          sake. By recognising these individuals and businesses, all of whom are
          rigorously and holistically evaluated, the intention is to spur them
          on their journey as well as hold them up as torch bearers for the
          sustainability movement.
        </p>
      </Column>
    </div>
  );
};
export default SIAAboutPage;
